(function () {
  'use strict';
  /* NPP Gallery Stack — 1 slide + desktop thumb sync */

  function setActiveDot(dots, index) {
    Array.prototype.forEach.call(dots, function (dot, dotIndex) {
      var isActive = dotIndex === index;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  }

  function setActiveThumb(thumbs, index) {
    Array.prototype.forEach.call(thumbs, function (thumb, thumbIndex) {
      thumb.classList.toggle('is-nav-selected', thumbIndex === index);
    });
  }

  function getSlideWidth(track) {
    var first = track.querySelector('[data-npp-gs-slide]');
    if (first && first.offsetWidth) {
      return first.offsetWidth;
    }
    return track.clientWidth;
  }

  function getActiveIndex(track) {
    var slideWidth = getSlideWidth(track);
    if (!slideWidth) return 0;
    return Math.round(track.scrollLeft / slideWidth);
  }

  function goToIndex(track, index) {
    var slideWidth = getSlideWidth(track);
    track.scrollTo({
      left: slideWidth * index,
      behavior: 'smooth'
    });
  }

  function getDesktopTrack(gallery) {
    var desktop = gallery.querySelector('[data-npp-gs-desktop]');
    return desktop ? desktop.querySelector('[data-npp-gs-track]') : null;
  }

  function initSlider(slider, gallery) {
    if (slider.dataset.nppGsReady === 'true') return;
    slider.dataset.nppGsReady = 'true';

    var track = slider.querySelector('[data-npp-gs-track]');
    var slides = slider.querySelectorAll('[data-npp-gs-slide]');
    var dots = slider.querySelectorAll('[data-npp-gs-dot]');
    var thumbs = gallery
      ? gallery.querySelectorAll('[data-npp-gs-thumb]')
      : [];

    if (!track || !slides.length) return;

    var scrollTimer;

    track.addEventListener(
      'scroll',
      function () {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(function () {
          var index = getActiveIndex(track);
          setActiveDot(dots, index);
          if (slider.hasAttribute('data-npp-gs-desktop')) {
            setActiveThumb(thumbs, index);
          }
        }, 80);
      },
      { passive: true }
    );

    Array.prototype.forEach.call(dots, function (dot) {
      dot.addEventListener('click', function () {
        var index = Number(dot.dataset.slideIndex || 0);
        goToIndex(track, index);
        setActiveDot(dots, index);
      });
    });

    track.scrollLeft = 0;
    setActiveDot(dots, 0);
  }

  function initThumbs(gallery) {
    if (!gallery || gallery.dataset.nppGsThumbsReady === 'true') return;
    gallery.dataset.nppGsThumbsReady = 'true';

    var thumbs = gallery.querySelectorAll('[data-npp-gs-thumb]');
    var desktopTrack = getDesktopTrack(gallery);

    if (!thumbs.length || !desktopTrack) return;

    Array.prototype.forEach.call(thumbs, function (thumb) {
      thumb.addEventListener('click', function () {
        var index = Number(thumb.dataset.slideIndex || 0);
        goToIndex(desktopTrack, index);
        setActiveThumb(thumbs, index);
      });
    });

    setActiveThumb(thumbs, 0);
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll('[data-npp-gs]');

    if (root && root.matches && root.matches('[data-npp-gs]')) {
      nodes = [root];
    }

    Array.prototype.forEach.call(nodes, function (gallery) {
      var stack = gallery.closest('.npp-gs-stack') || gallery.parentElement;

      gallery.querySelectorAll('[data-npp-gs-slider]').forEach(function (slider) {
        initSlider(slider, stack);
      });

      if (stack) {
        initThumbs(stack);
      }
    });
  }

  function syncOnResize() {
    document.querySelectorAll('[data-npp-gs-slider]').forEach(function (slider) {
      var track = slider.querySelector('[data-npp-gs-track]');
      var activeDot = slider.querySelector('[data-npp-gs-dot].is-active');
      if (!track) return;

      var index = activeDot ? Number(activeDot.dataset.slideIndex || 0) : getActiveIndex(track);
      track.scrollLeft = getSlideWidth(track) * index;
    });
  }

  function boot() {
    initAll(document);
    window.setTimeout(function () {
      document.querySelectorAll('[data-npp-gs-track]').forEach(function (track) {
        if (getActiveIndex(track) === 0) {
          track.scrollLeft = 0;
        }
      });
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event && event.target ? event.target : document;
    root.querySelectorAll('[data-npp-gs-slider]').forEach(function (slider) {
      slider.dataset.nppGsReady = 'false';
    });
    root.querySelectorAll('.npp-gs-stack').forEach(function (stack) {
      stack.dataset.nppGsThumbsReady = 'false';
    });
    initAll(root);
  });

  window.addEventListener('resize', function () {
    window.setTimeout(syncOnResize, 100);
  });

  window.addEventListener('orientationchange', function () {
    window.setTimeout(syncOnResize, 200);
  });
})();


